import { RSAA, getJSON } from 'redux-api-middleware';
import { ParticipantViewModel, ParticipantVirtualGraduationViewModel } from 'stageclip-common';

import { normalizeParticipantsArray } from '../normalizers/participantNormalizers';

import { InternalActionTypes } from 'constants/actionTypes';
import {
  CreateGetParticipantVgLink,
  CreateDeleteParticipant,
  CreateGetParticipantVgAdminLink,
  CreateGetParticipantActionsLog,
} from './participants.types';

const UPDATE_PARTICIPANT_REQUEST = 'UPDATE_PARTICIPANT_REQUEST';
export const UPDATE_PARTICIPANT_SUCCESS = 'UPDATE_PARTICIPANT_SUCCESS';
const UPDATE_PARTICIPANT_FAILURE = 'UPDATE_CLIENT_FAILURE';

type Body = {
  [key in keyof ParticipantViewModel]?: ParticipantViewModel[key];
} & {
  virtualGraduation?: {
    [key in keyof ParticipantVirtualGraduationViewModel]?: ParticipantVirtualGraduationViewModel[key];
  };
};

export const createEditParticipant = ({ id, ...body }: Body) => ({
  [RSAA]: {
    types: [UPDATE_PARTICIPANT_REQUEST, UPDATE_PARTICIPANT_SUCCESS, UPDATE_PARTICIPANT_FAILURE],
    endpoint: `/participants/${id}`,
    method: 'PATCH',
    body,
  },
});

const DELETE_PARTICIPANT_REQUEST = 'DELETE_PARTICIPANT_REQUEST';
const DELETE_PARTICIPANT_SUCCESS = InternalActionTypes.EventParticipantDeleted as string;
const DELETE_PARTICIPANT_FAILURE = 'DELETE_CLIENT_FAILURE';

export const createDeleteParticipant: CreateDeleteParticipant = (participantId, eventId) => ({
  [RSAA]: {
    types: [
      DELETE_PARTICIPANT_REQUEST,
      {
        type: DELETE_PARTICIPANT_SUCCESS,
        payload: () => ({ participantId, eventId }),
      },
      DELETE_PARTICIPANT_FAILURE,
    ],
    endpoint: `/participants/${participantId}`,
    method: 'DELETE',
  },
});

const PARTICIPANT_VG_LINK_REQUEST = 'PARTICIPANT_VG_LINK_REQUEST';
const PARTICIPANT_VG_LINK_SUCCESS = 'PARTICIPANT_VG_LINK_SUCCESS';
const PARTICIPANT_VG_LINK_FAILURE = 'PARTICIPANT_VG_LINK_FAILURE';

export const createGetParticipantVgLink: CreateGetParticipantVgLink = participantId => ({
  [RSAA]: {
    types: [
      PARTICIPANT_VG_LINK_REQUEST,
      {
        type: PARTICIPANT_VG_LINK_SUCCESS,
        meta: {
          externalResource: {
            open: true,
          },
        },
      },
      PARTICIPANT_VG_LINK_FAILURE,
    ],
    endpoint: `/participants/${participantId}/vg-link`,
    method: 'GET',
  },
});

const PARTICIPANT_VG_ADMIN_LINK_REQUEST = 'PARTICIPANT_VG_ADMIN_LINK_REQUEST';
const PARTICIPANT_VG_ADMIN_LINK_SUCCESS = 'PARTICIPANT_VG_ADMIN_LINK_SUCCESS';
const PARTICIPANT_VG_ADMIN_LINK_FAILURE = 'PARTICIPANT_VG_ADMIN_LINK_FAILURE';

export const createGetParticipantVgAdminLink: CreateGetParticipantVgAdminLink = participantId => ({
  [RSAA]: {
    types: [
      PARTICIPANT_VG_ADMIN_LINK_REQUEST,
      {
        type: PARTICIPANT_VG_ADMIN_LINK_SUCCESS,
        meta: {
          externalResource: {
            open: true,
          },
        },
      },
      PARTICIPANT_VG_ADMIN_LINK_FAILURE,
    ],
    endpoint: `/participants/${participantId}/vg-admin-link`,
    method: 'GET',
  },
});

const FETCH_QA_QUEUE_PARTICIPANTS_REQUEST = 'FETCH_QA_QUEUE_PARTICIPANTS_REQUEST';
export const FETCH_QA_QUEUE_PARTICIPANTS_SUCCESS = 'FETCH_QA_QUEUE_PARTICIPANTS_SUCCESS';
const FETCH_QA_QUEUE_PARTICIPANTS_FAILURE = 'FETCH_QA_QUEUE_PARTICIPANTS_FAILURE';

export const fetchQaQueueParticipants = () => ({
  [RSAA]: {
    types: [
      FETCH_QA_QUEUE_PARTICIPANTS_REQUEST,
      {
        type: FETCH_QA_QUEUE_PARTICIPANTS_SUCCESS,
        payload: (action: any, state: any, res: any) =>
          // @ts-ignore
          getJSON(res).then((json: any) => normalizeParticipantsArray(json)),
        meta: {
          unwrapPayload: true,
        },
      },
      FETCH_QA_QUEUE_PARTICIPANTS_FAILURE,
    ],
    endpoint: `/participants/queue`,
    method: 'GET',
  },
});

const FETCH_PARTICIPANTS_ACTIONS_LOG_REQUEST = 'FETCH_PARTICIPANTS_ACTIONS_LOG_REQUEST';
const FETCH_PARTICIPANTS_ACTIONS_LOG_SUCCESS = 'FETCH_PARTICIPANTS_ACTIONS_LOG_SUCCESS';
const FETCH_PARTICIPANTS_ACTIONS_LOG_FAILURE = 'FETCH_PARTICIPANTS_ACTIONS_LOG_FAILURE';

export const createGetParticipantActionsLog: CreateGetParticipantActionsLog = participantId => ({
  [RSAA]: {
    types: [
      FETCH_PARTICIPANTS_ACTIONS_LOG_REQUEST,
      FETCH_PARTICIPANTS_ACTIONS_LOG_SUCCESS,
      FETCH_PARTICIPANTS_ACTIONS_LOG_FAILURE,
    ],
    endpoint: `/participants/${participantId}/participant-actions`,
    method: 'GET',
  },
});

const FETCH_GLOBAL_PARTICIPANTS_REQUEST = 'FETCH_GLOBAL_PARTICIPANTS_REQUEST';
const FETCH_GLOBAL_PARTICIPANTS_SUCCESS = 'FETCH_GLOBAL_PARTICIPANTS_SUCCESS';
const FETCH_GLOBAL_PARTICIPANTS_FAILURE = 'FETCH_GLOBAL_PARTICIPANTS_FAILURE';

export const fetchParticipantsSearch = (search: string, active?: boolean, archived?: boolean) => ({
  [RSAA]: {
    types: [FETCH_GLOBAL_PARTICIPANTS_REQUEST, FETCH_GLOBAL_PARTICIPANTS_SUCCESS, FETCH_GLOBAL_PARTICIPANTS_FAILURE],
    endpoint: `/participants/search?q=${search}${archived !== undefined ? `&archived=${archived}` : ''}${
      active !== undefined ? `&active=${active}` : ''
    }`,
    method: 'GET',
  },
});
